export default __webpack_public_path__ + "static/media/project-8.e8730b17.jpg";